



















import { defineComponent, computed, PropType } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";

export default defineComponent({
    name: "SensorListItem",
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        SensorModule: () =>
            import(/* webpackChunkName: "components" */ "./SensorModule.vue"),
    },
    props: {
        icon: { type: String, required: true },
        img: { type: String, required: true },
        withMute: { type: Boolean, default: false },
        showStatusText: { type: Boolean, default: false },
        value: { type: Object as PropType<AttachedDeviceModel>, required: false },
    },
    setup(props, { emit }) {
        /** Whether the sensor is paired */
        const paired = computed(() =>
            !!(props.value?.attachedDeviceId && props.value.attachedDeviceId !== "")
        );

        /** Whether the sensor is currently connecting */
        const isConnecting = computed<boolean>(() => {
            return props.value?.isConnecting === true;
        });

        /** Whether the sensor is considered "responsive" based on age */
        const responsive = computed<boolean>(() => {
            return props.value?.attachedDeviceId
                ? (props.value.age ?? 99) <= 1
                : false;
        });

        /** Resolved image source */
        const imgSrc = computed<string>(() => {
            return require(`@/assets/img/${props.img}.png`);
        });

        function onEnroll() {
            if (props.value?.attachedDeviceTypeId != null) {
                const typeId = Number(props.value.attachedDeviceTypeId);
                emit('enroll', { typeId, img: imgSrc.value });
                console.log("DefaultSensorListItem onEnroll", typeId);
            } else {
                console.log("DefaultSensorListItem onEnroll typeId null");
            }
        }

        function onUnpair() {
            if (props.value?.attachedDeviceId != null) {
                const deviceId = props.value.attachedDeviceId;
                emit('unpair', { deviceId });
                console.log("DefaultSensorListItem onUnpair", deviceId);
            } else {
                console.log("DefaultSensorListItem onUnpair deviceId null");
            }
        }

        return {
            onEnroll,
            onUnpair,
            paired,
            responsive,
            imgSrc,
            isConnecting,
        };
    },
});
